import request from "@/utils/request";
import { AxiosPromise } from "axios";
import { UserForm, UserInfo, UserPageVO, UserQuery } from "./types";

/**
 * 登录成功后获取用户信息（昵称、头像、权限集合和角色集合）
 */
export function getUserInfo(): AxiosPromise<UserInfo> {
  return request({
    url: "/system/user/info",
    method: "get",
  });
}

/**
 * 获取用户分页列表
 *
 * @param queryParams
 */
export function getUserPage(
  queryParams: UserQuery
): AxiosPromise<PageResult<UserPageVO[]>> {
  return request({
    url: "/system/user/page",
    method: "get",
    params: queryParams,
  });
}

/**
 * 获取用户表单详情
 *
 * @param userId
 */
export function getUserForm(userId: number): AxiosPromise<UserForm> {
  return request({
    url: "/api/v1/users/" + userId + "/form",
    method: "get",
  });
}

/**
 * 添加用户
 *
 * @param data
 */
export function addUser(data: any) {
  return request({
    url: "/system/user",
    method: "post",
    data: data,
  });
}

/**
 * 修改用户
 *
 * @param data
 */
export function updateUser(data: UserForm) {
  const method = data.userId ? "put" : "post";
  return request("/system/user", {
    method,
    data,
  });
}

export function updateStatus(userId: number, lockFlag: string) {
  return request({
    url: `/system/user/disable`,
    method: "post",
    data: {
      userId,
      lockFlag,
    },
  });
}
/**
 * 修改用户密码
 *
 * @param id
 * @param password
 */
export function updateUserPassword(id: number) {
  return request({
    url: `/system/user/resetPwd/${id}`,
    method: "post",
  });
}

/**
 * 删除用户
 *
 * @param ids
 */
export function deleteUsers(id: number) {
  return request.delete(`/system/user/${id}`);
}

/**
 * 下载用户导入模板
 *
 * @returns
 */
export function downloadTemplateApi() {
  return request({
    url: "/api/v1/users/template",
    method: "get",
    responseType: "arraybuffer",
  });
}

// 获取用户表单详情
export function getUserDetail(id: number) {
  return request.get(`/system/user/${id}`);
}

export function getTotalData(params: any) {
  return request({
    url: "/system/user/statistics",
    method: "get",
    params,
  });
}

export function checkUserName(id: number, content: string) {
  let url = `/system/user/check?code=4&content=${content}`;
  if (id) {
    url += `&id=${id}`;
  }

  return request({
    url,
    method: "post",
  });
}

export function checkUserPhone(id: number, phone: string) {
  let url = `/system/user/check?code=5&content=${phone}`;
  if (id) {
    url += `&id=${id}`;
  }

  return request({
    url,
    method: "post",
  });
}
